import axios from 'axios'

const API_BASE = '/wp-json/wp/v2/'

export default {
  getCommissions ({ commit, state }) {
    if (state.commissions.length > 1) return

    return axios.get(apiUrl('posts'), { params: { per_page: 100 } }).then(({ data }) => {
      commit('GET_COMMISSIONS', data)
    })
  },
  getProjects ({ commit, state }) {
    if (state.projects.length > 1) return

    return axios.get(apiUrl('project'), { params: { per_page: 100 } }).then(({ data }) => {
      commit('GET_PROJECTS', data)
    })
  },

  getProject ({ commit, state }, { type, slug }) {
    let postType = type === 'projects' ? 'project' : 'posts'
    if (state[type].length) return

    return axios.get(apiUrl(postType), { params: { slug } }).then(({ data }) => {
      if (!data.length) throw new Error('404 Not Found')
      let post = data[0]
      commit('GET_PROJECT', { type, post })
    })
  },

  getPage ({ commit, state }, slug) {
    if (state.pages[slug]) return

    return axios.get(`/wp-json/oh/v1/pages/${slug}`).then(({ data }) => {
      commit('PAGE_LOADED', { slug, data })
    })
  }
}

function apiUrl (endpoint) {
  return API_BASE + endpoint
}



// WEBPACK FOOTER //
// ./src/store/actions.js